module.exports = __webpack_public_path__ + "img/gq.79e8fd3c.svg";